import LogService from "../../CommonSdk/LogService";

import * as UserService from "../../RainbowSdk/UserService";
import * as UserActionTypes from "./UserActionTypes";
import * as AuthenticationActions from "./AuthenticationActions";
import * as CustomDataUtils from "../../Utils/CustomDataUtils";

const LOG_TAG = "ACTIONS:USER";

export const updateUserPassword = (user, oldPassword, newPassword) => dispatch => {
    LogService.trace(LOG_TAG, "updateUserPassword", "Update password");

    const userId = user.id;
    const userLoginEmail = user.loginEmail;

    return UserService.updateUserPassword(userId, oldPassword, newPassword)
        .then(json => {
            LogService.trace(LOG_TAG, "Success", json);

            //If successfully change the user is re-authen automatically
            return dispatch(AuthenticationActions.login(
                {
                    email: userLoginEmail,
                    password: newPassword
                })
            )
        })
        .then(() => {
            LogService.info(LOG_TAG, "re-authentication successful");
            return Promise.resolve();
        })
        .catch(errorPayload => {
            LogService.error(LOG_TAG, "Error", errorPayload);
            return Promise.reject(errorPayload);
        })
}

export const getUserCustomData = () => dispatch => {
    LogService.trace(LOG_TAG, "getUserCustomData", "enter");

    return UserService.getUserCustomData()
        .then(data => {
            dispatch({
                type: UserActionTypes.USER_CUSTOM_DATA_SUCCESS,
                payload: {
                    customData: data
                }
            });
            return Promise.resolve(data);
        })
        .catch(errorPayload => {
            LogService.error(LOG_TAG, "getUserCustomData", "Error retreiving user custom data", errorPayload);
            return Promise.reject(errorPayload);
        });
}

export const setUserCustomData = (customData) => dispatch => {
    LogService.trace(LOG_TAG, "setUserCustomData", "enter");

    return UserService.setUserCustomData(customData)
        .then(data => {
            dispatch({
                type: UserActionTypes.USER_CUSTOM_DATA_SUCCESS,
                payload: {
                    customData: data
                }
            });
            return Promise.resolve(data);
        })
        .catch(errorPayload => {
            LogService.error(LOG_TAG, "setUserCustomData", "Error retreiving user custom data", errorPayload);
            return Promise.reject(errorPayload);
        });
}

export const updateSearchPreferences = (searchPreferenceList) => (dispatch, getState) => {
    LogService.trace(LOG_TAG, "updateSearchPreferences", "enter");

    let customData = CustomDataUtils.updateSearchIndexPreference(getState().user.customUserData, searchPreferenceList);
    return dispatch(setUserCustomData(customData))
        .then((data) => {
            return Promise.resolve(data);
        })
        .catch(errorPayload => {
            return Promise.reject(errorPayload);
        });
}

export const updateThemePreferences = (theme) => (dispatch, getState) => {
    LogService.trace(LOG_TAG, "updateThemePreferences", "enter");

    let customData = CustomDataUtils.updateThemePreferences(getState().user.customUserData, theme);
    return dispatch(setUserCustomData(customData))
        .then((data) => {
            return Promise.resolve(data);
        })
        .catch(errorPayload => {
            return Promise.reject(errorPayload);
        });
}

